import React, { Component, useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Dropdown } from "react-bootstrap";
// import { Trans } from 'react-i18next';
const Trans = ({ children }) => <>{children}</>;
import axios from "axios";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/admin", state: "adminMenu" },
      { path: "/game", state: "gameMenu" },
      { path: "/user", state: "userMenu" },
      { path: "/agent", state: "agentMenu" },
      { path: "/challenge", state: "challengeMenu" },
      { path: "/transaction", state: "transactionMenu" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
      { path: "/Reports", state: "reportsMenu" }, //Added By Team
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  render() {
    var appURL = process.env.PUBLIC_URL;
    var logo =
      appURL + "https://img.icons8.com/dotty/512/admin-settings-male.png";
    // foreach props
    for (let key in this.props) {
      if (this.props[key] === undefined) {
        setTimeout(() => {}, 1000);
      }
    }

    return (
      <nav
        className="sidebar sidebar-offcanvas"
        id="sidebar"
        style={{
          background: "#0A0E29",
          borderRight: "1px solid rgba(80, 70, 229, 0.25)",
          boxShadow: "4px 0 20px rgba(0, 0, 0, 0.35)",
          paddingTop: "75px",
          overflowY: "auto",
          zIndex: 999,
        }}
      >
        <ul className="nav pt-3">
          {this.props.dashboard && (
            <li
              className={
                this.isPathActive("/dashboard")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <Link
                className="nav-link"
                to="/dashboard"
                style={{
                  color: "#ffffff",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/dashboard")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/dashboard")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background: this.isPathActive("/dashboard")
                      ? "rgba(255, 255, 255, 0.2)"
                      : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(99, 102, 241, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-speedometer"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span
                  className="menu-title"
                  style={{
                    fontWeight: this.isPathActive("/dashboard") ? "600" : "500",
                    color: "#ffffff",
                  }}
                >
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>
          )}
          {this.props.earnings && (
            <li
              className={
                this.isPathActive("/earinigs")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <Link
                className="nav-link"
                to="/earinigs"
                style={{
                  color: this.isPathActive("/earinigs") ? "#ffffff" : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/earinigs")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/earinigs")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(168, 85, 247, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-cash-usd"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>Admin Earnings</Trans>
                </span>
              </Link>
            </li>
          )}
          {(this.props.allAdmins ||
            this.props.newAdmin ||
            this.props.sitesettings ||
            this.props.twilioConfig) && (
            <li
              className={
                this.isPathActive("/admin")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <div
                className={
                  this.state.adminMenu ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("adminMenu")}
                data-toggle="collapse"
                style={{
                  color: this.isPathActive("/admin") ? "#ffffff" : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/admin")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/admin")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(245, 158, 11, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-account-cog"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>Admin Manager</Trans>
                </span>
                <i
                  className="menu-arrow mdi mdi-chevron-down"
                  style={{
                    marginLeft: "auto",
                    transition: "transform 0.3s ease",
                    transform: this.state.adminMenu
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    color: "#94a3b8",
                  }}
                ></i>
              </div>
              <Collapse in={this.state.adminMenu}>
                <div>
                  <ul
                    className="nav flex-column sub-menu"
                    style={{
                      background: "rgba(14, 21, 56, 0.75)",
                      borderRadius: "10px",
                      margin: "0.35rem 0.6rem 0.5rem 1.6rem",
                      padding: "0.5rem 0",
                      borderLeft: "2px solid rgba(80, 70, 229, 0.4)",
                    }}
                  >
                    {this.props.allAdmins && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/admin/alladmins")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/alladmins"
                          style={{
                            color: this.isPathActive("/admin/alladmins")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/admin/alladmins")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>All Admins</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allAdmins && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/admin/adminchallenges")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/adminchallenges"
                          style={{
                            color: this.isPathActive("/admin/adminchallenges")
                              ? "#6366f1"
                              : "#cbd5e1",
                            padding: "0.5rem 1.5rem",
                            fontSize: "0.875rem",
                            fontWeight: this.isPathActive(
                              "/admin/adminchallenges",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Admin Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newAdmin && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/admin/addadmin")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/addadmin"
                          style={{
                            color: this.isPathActive("/admin/addadmin")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/admin/addadmin")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Add Manager</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.sitesettings && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/admin/sitesettings")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/sitesettings"
                          style={{
                            color: this.isPathActive("/admin/sitesettings")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/admin/sitesettings")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Website Settings</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.twilioConfig && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/admin/twilio-config")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/admin/twilio-config"
                          style={{
                            color: this.isPathActive("/admin/twilio-config")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/admin/twilio-config",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Twilio SMS Config</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}

          {/* {(this.props.allAdmins || this.props.newAdmin) && (
            <li className={this.isPathActive('/agent') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.agentMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('agentMenu')} data-toggle="collapse" style={{
                color: this.isPathActive('/agent') ? 'white' : '#cbd5e1',
                borderRadius: '8px',
                margin: '0 0.5rem',
                padding: '0.75rem 1rem',
                transition: 'all 0.3s ease',
                background: this.isPathActive('/agent') ? 'rgba(139, 0, 0, 0.2)' : 'transparent',
                boxShadow: this.isPathActive('/agent') ? '0 4px 6px rgba(99, 102, 241, 0.3)' : 'none',
                cursor: 'pointer'
              }}>
                <span className="menu-icon" style={{ marginRight: '0.75rem' }}>
                  <i className="mdi mdi-account-star" style={{ fontSize: '1.1rem' }}></i>
                </span>
                <span className="menu-title" style={{ fontWeight: '500' }}>
                  <Trans>Agent Manager</Trans>
                </span>
                <i className="menu-arrow" style={{ 
                  marginLeft: 'auto',
                  transition: 'transform 0.3s ease',
                  transform: this.state.agentMenu ? 'rotate(180deg)' : 'rotate(0deg)'
                }}></i>
              </div>
              <Collapse in={this.state.agentMenu}>
                <div>
                  <ul className="nav flex-column sub-menu" style={{ 
                    background: 'rgba(15, 23, 42, 0.5)',
                    borderRadius: '8px',
                    margin: '0 0.5rem',
                    padding: '0.5rem 0'
                  }}>
                    {this.props.allAdmins && (
                      <li className="nav-item"> 
                        <Link className={this.isPathActive('/agent/allagents') ? 'nav-link active' : 'nav-link'} to="/agent/allagents" style={{
                          color: this.isPathActive('/agent/allagents') ? '#6366f1' : '#cbd5e1',
                          padding: '0.5rem 1.5rem',
                          fontSize: '0.875rem',
                          fontWeight: this.isPathActive('/agent/allagents') ? '600' : '400'
                        }}>
                          <Trans>All Agents</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newAdmin && (
                      <li className="nav-item"> 
                        <Link className={this.isPathActive('/agent/addagent') ? 'nav-link active' : 'nav-link'} to="/agent/addagent" style={{
                          color: this.isPathActive('/agent/addagent') ? '#6366f1' : '#cbd5e1',
                          padding: '0.5rem 1.5rem',
                          fontSize: '0.875rem',
                          fontWeight: this.isPathActive('/agent/addagent') ? '600' : '400'
                        }}>
                          <Trans>Add New Agent</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )} */}
          {(this.props.allUsers ||
            this.props.newUser ||
            this.props.pendingKyc ||
            this.props.completedKyc ||
            this.props.rejectKyc) && (
            <li
              className={
                this.isPathActive("/user")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <div
                className={
                  this.state.userMenu ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("userMenu")}
                data-toggle="collapse"
                style={{
                  color: this.isPathActive("/user") ? "#ffffff" : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/user")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/user")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(244, 63, 94, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-account-group"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>User Manager</Trans>
                </span>
                <i
                  className="menu-arrow mdi mdi-chevron-down"
                  style={{
                    marginLeft: "auto",
                    transition: "transform 0.3s ease",
                    transform: this.state.userMenu
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    color: "#94a3b8",
                  }}
                ></i>
              </div>
              <Collapse in={this.state.userMenu}>
                <div>
                  <ul
                    className="nav flex-column sub-menu"
                    style={{
                      background: "rgba(14, 21, 56, 0.75)",
                      borderRadius: "10px",
                      margin: "0.35rem 0.6rem 0.5rem 1.6rem",
                      padding: "0.5rem 0",
                      borderLeft: "2px solid rgba(80, 70, 229, 0.4)",
                    }}
                  >
                    {this.props.allUsers && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/user/allusers")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/user/allusers"
                          style={{
                            color: this.isPathActive("/user/allusers")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/user/allusers")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>View All Users</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newUser && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/user/adduser")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/user/adduser"
                          style={{
                            color: this.isPathActive("/user/adduser")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/user/adduser")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Add New User</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.pendingKyc && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/user/UserKyc")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/user/UserKyc"
                          style={{
                            color: this.isPathActive("/user/UserKyc")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/user/UserKyc")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Pending KYC</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.completedKyc && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/user/kyc")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/user/kyc"
                          style={{
                            color: this.isPathActive("/user/kyc")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/user/kyc")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Completed KYC</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.rejectKyc && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/user/reject")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/user/reject"
                          style={{
                            color: this.isPathActive("/user/reject")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive("/user/reject")
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Reject KYC</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {(this.props.allChallenges ||
            this.props.completedChallenges ||
            this.props.conflictChallenges ||
            this.props.cancelledChallenges ||
            this.props.runningChallenges ||
            this.props.newChallenge ||
            this.props.dropChallenge) && (
            <li
              className={
                this.isPathActive("/challenge")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <div
                className={
                  this.state.challengeMenu
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("challengeMenu")}
                data-toggle="collapse"
                style={{
                  color: this.isPathActive("/challenge")
                    ? "#ffffff"
                    : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/challenge")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/challenge")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(6, 182, 212, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-gamepad-variant"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>Challenge Manager</Trans>
                </span>
                <i
                  className="menu-arrow mdi mdi-chevron-down"
                  style={{
                    marginLeft: "auto",
                    transition: "transform 0.3s ease",
                    transform: this.state.challengeMenu
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    color: "#94a3b8",
                  }}
                ></i>
              </div>
              <Collapse in={this.state.challengeMenu}>
                <div>
                  <ul
                    className="nav flex-column sub-menu"
                    style={{
                      background: "rgba(14, 21, 56, 0.75)",
                      borderRadius: "10px",
                      margin: "0.35rem 0.6rem 0.5rem 1.6rem",
                      padding: "0.5rem 0",
                      borderLeft: "2px solid rgba(80, 70, 229, 0.4)",
                    }}
                  >
                    {this.props.allChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/allchallenges")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/allchallenges"
                          style={{
                            color: this.isPathActive("/challenge/allchallenges")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/allchallenges",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>View All Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.completedChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/completed_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/completed_challange"
                          style={{
                            color: this.isPathActive(
                              "/challenge/completed_challange",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/completed_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Completed Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.conflictChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/conflict_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/conflict_challange"
                          style={{
                            color: this.isPathActive(
                              "/challenge/conflict_challange",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/conflict_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Conflict Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.cancelledChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/cancelled_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/cancelled_challange"
                          style={{
                            color: this.isPathActive(
                              "/challenge/cancelled_challange",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/cancelled_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Cancelled Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.runningChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/running_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/running_challange"
                          style={{
                            color: this.isPathActive(
                              "/challenge/running_challange",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/running_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Running Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.dropChallenges && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/drop_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/drop_challange"
                          style={{
                            color: this.isPathActive(
                              "/challenge/drop_challange",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/drop_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Drop Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.newChallenge && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/challenge/new_challange")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/challenge/new_challange"
                          style={{
                            color: this.isPathActive("/challenge/new_challange")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/challenge/new_challange",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>New Challenges</Trans>
                        </Link>
                      </li>
                    )}
                    <li className="nav-item">
                      <Link
                        className={
                          this.isPathActive("/challenge/check_result")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/challenge/check_result"
                        style={{
                          color: this.isPathActive("/challenge/check_result")
                            ? "#fbbf24"
                            : "#f59e0b",
                          padding: "0.45rem 1.25rem",
                          fontSize: "0.84rem",
                          fontWeight: "bold",
                        }}
                      >
                        <Trans>⚡ Check Auto Result</Trans>
                      </Link>
                    </li>
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {(this.props.penaltyBonus ||
            this.props.depositHistory ||
            this.props.withdrawlHistory ||
            this.props.allWithdrawlRequests ||
            this.props.allDepositRequests) && (
            <li
              className={
                this.isPathActive("/transaction")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <div
                className={
                  this.state.transactionMenu
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("transactionMenu")}
                data-toggle="collapse"
                style={{
                  color: this.isPathActive("/transaction")
                    ? "#ffffff"
                    : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/transaction")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/transaction")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(16, 185, 129, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-swap-horizontal"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>Transaction Manager</Trans>
                </span>
                <i
                  className="menu-arrow mdi mdi-chevron-down"
                  style={{
                    marginLeft: "auto",
                    transition: "transform 0.3s ease",
                    transform: this.state.transactionMenu
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    color: "#94a3b8",
                  }}
                ></i>
              </div>
              <Collapse in={this.state.transactionMenu}>
                <div>
                  <ul
                    className="nav flex-column sub-menu"
                    style={{
                      background: "rgba(14, 21, 56, 0.75)",
                      borderRadius: "10px",
                      margin: "0.35rem 0.6rem 0.5rem 1.6rem",
                      padding: "0.5rem 0",
                      borderLeft: "2px solid rgba(80, 70, 229, 0.4)",
                    }}
                  >
                    {this.props.penaltyBonus && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transaction/penaltybonus")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/penaltybonus"
                          style={{
                            color: this.isPathActive(
                              "/transaction/penaltybonus",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/penaltybonus",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Penalty & Bonus</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.depositHistory && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive(
                              "/transaction/transaction_history",
                            )
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/transaction_history"
                          style={{
                            color: this.isPathActive(
                              "/transaction/transaction_history",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/transaction_history",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Deposit History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.bonusHistory && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transaction/bonus_history")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/bonus_history"
                          style={{
                            color: this.isPathActive(
                              "/transaction/bonus_history",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/bonus_history",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Bonus History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.withdrawlHistory && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transaction/withdraw")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/withdraw"
                          style={{
                            color: this.isPathActive("/transaction/withdraw")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/withdraw",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Withdrawal History</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allWithdrawlRequests && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transaction/allwithdrawl")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/allwithdrawl"
                          style={{
                            color: this.isPathActive(
                              "/transaction/allwithdrawl",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/allwithdrawl",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>View All Withdrawal Requests</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.allDepositRequests && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transaction/alldeposits")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transaction/alldeposits"
                          style={{
                            color: this.isPathActive("/transaction/alldeposits")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/transaction/alldeposits",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>View All Deposit Requests</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {(this.props.bonusReport ||
            this.props.depositReport ||
            this.props.penaltyReport ||
            this.props.withdrawlReport) && (
            <li
              className={
                this.isPathActive("/reports")
                  ? "nav-item menu-items active mb-1"
                  : "nav-item menu-items mb-1"
              }
            >
              <div
                className={
                  this.state.reportsMenu ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("reportsMenu")}
                data-toggle="collapse"
                style={{
                  color: this.isPathActive("/reports") ? "#ffffff" : "#94a3b8",
                  borderRadius: "12px",
                  margin: "0 0.6rem",
                  padding: "0.7rem 1rem",
                  transition: "all 0.3s ease",
                  background: this.isPathActive("/reports")
                    ? "linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #3b82f6 100%)"
                    : "transparent",
                  boxShadow: this.isPathActive("/reports")
                    ? "0 8px 24px rgba(99, 102, 241, 0.45)"
                    : "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "0.85rem",
                    flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(139, 92, 246, 0.4)",
                  }}
                >
                  <i
                    className="mdi mdi-poll-box"
                    style={{ fontSize: "1.15rem", color: "#ffffff" }}
                  ></i>
                </span>
                <span className="menu-title" style={{ fontWeight: "500" }}>
                  <Trans>Reports</Trans>
                </span>
                <i
                  className="menu-arrow mdi mdi-chevron-down"
                  style={{
                    marginLeft: "auto",
                    transition: "transform 0.3s ease",
                    transform: this.state.reportsMenu
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    color: "#94a3b8",
                  }}
                ></i>
              </div>
              <Collapse in={this.state.reportsMenu}>
                <div>
                  <ul
                    className="nav flex-column sub-menu"
                    style={{
                      background: "rgba(14, 21, 56, 0.75)",
                      borderRadius: "10px",
                      margin: "0.35rem 0.6rem 0.5rem 1.6rem",
                      padding: "0.5rem 0",
                      borderLeft: "2px solid rgba(80, 70, 229, 0.4)",
                    }}
                  >
                    {this.props.bonusReport && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/Reports/bonus_report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/Reports/bonusReport"
                          style={{
                            color: this.isPathActive("/Reports/bonus_report")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/Reports/bonus_report",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Bonus Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.depositReport && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/Reports/deposit_report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/Reports/depositReport"
                          style={{
                            color: this.isPathActive("/Reports/deposit_report")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/Reports/deposit_report",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Deposit Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.penaltyReport && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/Reports/penalty_report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/Reports/penaltyReport"
                          style={{
                            color: this.isPathActive("/Reports/penalty_report")
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/Reports/penalty_report",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Penalty Report</Trans>
                        </Link>
                      </li>
                    )}
                    {this.props.withdrawalReport && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/Reports/withdrawal_report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/Reports/withdrawalReport"
                          style={{
                            color: this.isPathActive(
                              "/Reports/withdrawal_report",
                            )
                              ? "#818cf8"
                              : "#94a3b8",
                            padding: "0.45rem 1.25rem",
                            fontSize: "0.84rem",
                            fontWeight: this.isPathActive(
                              "/Reports/withdrawal_report",
                            )
                              ? "600"
                              : "400",
                          }}
                        >
                          <Trans>Withdrawal Report</Trans>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withRouter(Sidebar);
